var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrolly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.4,10.2L12.4,10.2L9.7,9.4l1.9-1.3h0c0,0,0,0.4,0,0.4l-1.1,0.8L12.4,10.2C12.4,10.1,12.4,10.2,12.4,10.2L12.4,10.2z"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#000"
    },
    points: "11,10 11,10.4 10.1,10.4 10.1,10  "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    x: 11.5,
    y: 10,
    width: 1.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,12.5c-0.8-1.4-1-2.2-1.7-2.2H3c-0.4,0-0.8,0.4-1,0.9c0,0-0.8,2.1-0.8,2.1C1,13.5,1,13.6,1,13.8h22 C23,13.3,22.8,13,22.6,12.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,14.5h21.8l-0.1,0.2l0,0.1c0.1-0.4,0.2-0.5,0.2-0.7H1C1,14.3,1,14.4,1,14.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M22.9,14.2c0-0.1,0-0.2,0-0.4C22.9,14,22.9,14.1,22.9,14.2z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6,16h20.8l0.3-1.1H1.1C1.3,15.3,1.5,15.7,1.6,16z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M22.9,14.2C22.9,14.2,22.9,14.2,22.9,14.2C22.9,14.2,22.9,14.2,22.9,14.2L22.9,14.2z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1,13.8c0,0.1,0,0.3,0,0.4h21.9l0,0c0-0.1,0-0.2,0-0.4H1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,14.5H1c0,0.1,0.1,0.3,0.1,0.4h21.6l0-0.1L22.8,14.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.4,13.4c0,0.1-0.1,0.3-0.2,0.3h-1.2c-0.1,0-0.2-0.1-0.2-0.3V12c0-0.1,0.1-0.3,0.2-0.3h1.3c0.1,0,0.2,0.1,0.2,0.2 C12.4,11.9,12.4,11.9,12.4,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M8.6,13.4c0,0.1-0.1,0.3-0.2,0.3H7.1c-0.1,0-0.2-0.1-0.2-0.3V12c0-0.1,0.1-0.3,0.2-0.3h1.2c0.1,0,0.2,0.1,0.2,0.2 C8.6,11.9,8.6,11.9,8.6,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.4,12.2L2.4,12.2c0,0.1,0,0.2,0,0.4s0,0.4,0,0.7c0,0.1-0.1,0.3-0.2,0.3H1c0-0.2,0-0.1,0.7-2h0.4c0.1,0,0.2,0.1,0.2,0.2 C2.4,11.9,2.4,11.9,2.4,12.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.5,13.4c0,0.1-0.1,0.3-0.2,0.3h-1.2c-0.1,0-0.2-0.1-0.2-0.3V12c0-0.1,0.1-0.3,0.2-0.3h1.2c0.1,0,0.2,0.1,0.2,0.2 C16.5,11.9,16.5,11.9,16.5,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,13.6h-1.6c-0.1,0-0.3-0.1-0.3-0.3V12c0-0.1,0.1-0.3,0.3-0.3h0.8c0,0.1,0.1,0.2,0.2,0.3s0.1,0.1,0.1,0.2c0,0,0,0,0,0 c0.1,0.2,0.2,0.4,0.3,0.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0.1,0.3C23,13.3,23,13.4,23,13.6C23,13.6,23,13.6,23,13.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19,12.3L19,12.3c-0.5,0-0.8,0.4-0.8,0.7v3.5h1.5v-3.5C19.8,12.7,19.4,12.3,19,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.3,12.3H4.2c-0.4,0-0.7,0.4-0.7,0.7v3.5H5v-3.5C5,12.7,4.7,12.3,4.3,12.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.6,8.6L11.6,8.6c-0.1,0-0.2-0.1-0.2-0.3V7.5h0.4v0.9C11.8,8.5,11.8,8.6,11.6,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M22.2,16.5H1.7c-0.4,0-0.2-0.3-0.2-0.6h21C22.5,16.3,22.6,16.5,22.2,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolly);
export default __webpack_public_path__ + "static/media/trolly.6de46b4d2b2e28470e82fd4abcfc0497.svg";
export { ForwardRef as ReactComponent };